module.exports = __webpack_public_path__ + "c4e4a4e438e3e2f1d1fc133712dfccc3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-54.png
// module id = 132
// module chunks = 0